if (!customElements.get('slider-component')) {
  customElements.define('slider-component', class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      this.update();

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    }

    update() {
      if (this.prevButton) this.prevButton.disabled = this.slider.scrollLeft <= 0;
      if (this.nextButton) this.nextButton.disabled = this.slider.scrollLeft + this.slider.clientWidth >= this.slider.scrollWidth;
      
      this.querySelectorAll('.slider-counter--current').forEach((counter) => {
        const currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        counter.textContent = currentPage;
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.name === 'next' ? 1 : -1;
      this.slider.scrollTo({
        left: this.slider.scrollLeft + (step * this.sliderItemOffset),
        behavior: 'smooth'
      });
    }
  });
}